import { useState, useEffect } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
import { toast } from "react-toastify";
import { useThemeManager } from "../Hooks/ThemeManager";

/*-----Bootstrap-----*/
import Form from "react-bootstrap/Form";

/*-----Hoja de estilo-----*/
import "../styles/login.css";

/*-----Utils-----*/
import { getFullUrl } from "../utils/config.js";

/*-----Iconos-----*/
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import { IoArrowBack } from "react-icons/io5";
import { MdSendToMobile } from "react-icons/md";

const RegisterCode = ({ next, animation, setContact, setRif, setMethod, logoUrl }) => {
  const { themeColors } = useThemeManager();

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const submit = async (event) => {
    event.preventDefault();
    setRif(event.target.rif.value);
    setMethod(watch("method"));
    const method = watch("method");
    const rif = event.target.rif.value;

    if (method) {
      const data = {
        identity: rif,
        method: method,
        access: "juridico",
      };
      try {
        const response = await axios.post(
          "https://mi.fibra360.net/api/auth/send-verification-code",
          data
        );

        if (response?.data?.status == "success") {
          next();
          setContact(
            method === "sms"
              ? response.data.data.telefono
              : response.data.data.correo
          );
        }
      } catch (error) {
        if (
          error?.response?.data?.status == "error" &&
          error?.response?.data?.message == "cuenta registrada"
        ) {
          toast.error("Disculpe, la cuenta ya se encuentra registrada.");
        }
      }
    } else {
      toast.error("Por favor, seleccione un método de envío.");
    }
  };

  return (
    <div className="containerBody">
      <div className={`loginContainer ${animation}`}>
        <div className="container">
          <Link to="/" className="back">
            <IoArrowBack />
          </Link>
          <div className="logoContainer">
            <img src={logoUrl} alt="Logo 360" />
          </div>
          <div className="info">
            <span className="titulo">Registro</span>
            <span>
              ¿Ya posee una cuenta?{" "}
              <Link to="/" className="links">
                Iniciar Sesión
              </Link>
            </span>
          </div>
          <form className="formulario" onSubmit={submit}>
            <div className="formGroup">
              <input
                className="formInput"
                {...register("rif")}
                placeholder=" "
              />
              <label className="formLabel">Ingrese el número de RIF</label>
            </div>
            Enviar Código:
            <div className="formGroupRegister">
              <label className="checkboxCode">
                <Form.Check
                  className="check"
                  type="radio"
                  {...register("method")}
                  value="sms"
                />{" "}
                Telefono
              </label>
              <label className="checkboxCode">
                <Form.Check
                  className="check"
                  type="radio"
                  {...register("method")}
                  value="email"
                />{" "}
                Correo Electrónico
              </label>
            </div>
            <button type="submit" className="buttonSubmit bg-primary">
              Continuar
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

const RegisterVeriCode = ({
  prev,
  next,
  animation,
  contact,
  rif,
  method,
  setCodigo,
  setCorreo,
  logoUrl
}) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const { themeColors } = useThemeManager();

  const submit = async (event) => {
    event.preventDefault();
    const code = event.target.code.value;

    try {
      const response = await axios.post(
        "https://mi.fibra360.net/api/auth/verify-code",
        {
          identity: rif,
          code: code,
        }
      );
      if (response?.data?.status == "success") {
        next();
        setCodigo(code);
        setCorreo(response.data.data.correo);
      }
    } catch (error) {
      if (error?.response?.data?.status == "error") {
        toast.error("El codigo no es válido o no existe.");
      }
    }
  };

  const reenviarCodigo = async (event) => {
      const data = {
        identity: rif,
        method: method,
        access: "juridico",
      };
      try {
        const response = await axios.post(
          "https://mi.fibra360.net/api/auth/send-verification-code",
          data
        );
        if (response?.data.status == "success") {
          toast.success("Se ha reenviado correctamente el código.");
          setTiempoAgotado(false);
          setTiempoRestante(120);
        }
      } catch (error) {
        toast.error("Ha ocurrido un error al reenviar el código.");
      }
  };

  const [tiempoRestante, setTiempoRestante] = useState(120);
  const [tiempoAgotado, setTiempoAgotado] = useState(false);
  const minutos = Math.floor(tiempoRestante / 60);
  const segundos = tiempoRestante % 60;


  useEffect(() => {
    // Cuando el tiempo llegue a 0
    if (tiempoRestante <= 0) {
      setTiempoAgotado(true);
      return;
    }

    // Crear un intervalo que se ejecute cada segundo
    const idIntervalo = setInterval(() => {
      setTiempoRestante(tiempoRestante - 1);
    }, 1000);

    // Limpiar el intervalo cuando el componente se desmonte o el tiempo se actualice
    return () => clearInterval(idIntervalo);
  }, [tiempoRestante]);

  return (
    <div className="containerBody">
      <div className={`loginContainer ${animation}`}>
        <div className="container">
          <Link onClick={prev} className="back">
            <IoArrowBack />
          </Link>
          <div className="logoContainer">
            <img src={logoUrl} alt="Logo 360" />
          </div>
          <div className="info">
            <span className="titulo">Registro</span>
            <span>
              ¿Ya posee una cuenta?{" "}
              <Link to="/" className="links">
                Iniciar Sesión
              </Link>
            </span>
          </div>
          <form className="formularioVeri" onSubmit={submit}>
            <span>Se ha enviado un código de seguridad:</span>
            <span>{contact}</span>
            <div className="formGroup">
              <input
                className="formInput"
                {...register("code")}
                placeholder=" "
              />
              <label className="formLabel">Ingrese el código</label>
            </div>
            {tiempoAgotado ? 
            <div className="reenviarCode">
             <span className="code" >Reenviar código: </span> <div className="buttonReenviar loginIn" onClick={() => { reenviarCodigo();}} ><MdSendToMobile className="iconReenviar"/> Reenviar</div> 
            </div>
            :
            <span className="code">Reenviar código: <span className="timeReenviar">{minutos.toString().padStart(2, '0')}:{segundos.toString().padStart(2, '0')}</span></span>
            }
            <button type="submit" className="buttonSubmit bg-secondary">
              Continuar
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

const RegisterPassword = ({ prev, next, animation, rif, codigo, correo, setCorreo, logoUrl }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const navigate = useNavigate();
  const { themeColors } = useThemeManager();

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, touchedFields },
  } = useForm({
    mode: "onSubmit",
    criteriaMode: "all",
    defaultValues: {
      password: "",
      confirmPassword: "",
    },
  });
  
  const password = watch("password");
  const confirmPassword = watch("confirmPassword");

  const handleCorreoChange = (event) => {
    setCorreo(event.target.value);
  };

  const submit = async (data) => {

    const enteredPassword = data.password;

    try {
      const response = await axios.post(
        "https://mi.fibra360.net/api/auth/register-juridico",
        {
          identity: rif,
          code: codigo,
          password: enteredPassword,
          correo: correo
        }
      );

      if (response?.data?.status == "success") {
        toast.success("Se ha registrado correctamente.");
        navigate("/");
      }
    } catch (error) {
      if (error?.response?.data?.status == "error") {
        toast.error("No se ha podido registrar el usuario.");
      }
    }
  };

  return (
    <div className="containerBody">
      <div className={`loginContainer ${animation}`}>
        <div className="container">
          <Link onClick={prev} className="back">
            <IoArrowBack />
          </Link>
          <div className="logoContainer">
            <img src={logoUrl} alt="Logo 360" />
          </div>
          <div className="info">
            <span className="titulo">Registro</span>
            <span>
              ¿Ya posee una cuenta?{" "}
              <Link to="/" className="links">
                Iniciar Sesión
              </Link>
            </span>
          </div>
          <form className="formulario" onSubmit={handleSubmit(submit)}>
            <div className="formGroup">
              <input
                className="formInput"
                {...register("email")}
                placeholder=" "
                value={correo}
                onChange={handleCorreoChange}
              />
              <label className="formLabel">Correo Electrónico</label>
            </div>
            <div className="formGroup">
              <input
                className="formInput"
                type={showPassword ? "text" : "password"}
                {...register("password", {
                  required: "¡Este campo es requerido!",
                  minLength: {
                    value: 6,
                    message: "¡Deben ser al menos 6 caracteres!",
                  },
                })}
                placeholder=" "
              />
              <label className="formLabel">Contraseña</label>
              {errors.password && <p className="errors">{errors.password.message}</p>}
              <div
                onClick={() => {
                  setShowPassword(!showPassword);
                }}
              >
                {showPassword ? (
                  <FaEye className="iconEye" />
                ) : (
                  <FaEyeSlash className="iconEye2" />
                )}
              </div>
            </div>
            <div className="formGroup mb-5">
            <input
            className="formInput"
            type={showPassword2 ? "text" : "password"}
            {...register("confirmPassword", {
              required: "¡Este campo es requerido!",
              minLength: {
                value: 6,
                message: "¡Deben ser al menos 6 caracteres!",
              },
              validate: value =>
                value === password || "¡Las contraseñas no coinciden!",
            })}
            placeholder=" "
          />
          <label className="formLabel">Confirmar Contraseña</label>
          {errors.confirmPassword && <p className="errors">{errors.confirmPassword.message}</p>}
              <div
                onClick={() => {
                  setShowPassword2(!showPassword2);
                }}
              >
                {showPassword2 ? (
                  <FaEye className="iconEye" />
                ) : (
                  <FaEyeSlash className="iconEye2" />
                )}
              </div>
            </div>
            <button type="submit" className="buttonSubmit bg-secondary">
              Registar
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

const RegisterView = () => {
  const [step, setStep] = useState(1);
  const [animation, setAnimation] = useState("slide-in");
  const [contact, setContact] = useState("");
  const [codigo, setCodigo] = useState("");
  const [rif, setRif] = useState("");
  const [method, setMethod] = useState("");
  const [correo, setCorreo] = useState("");
  const [logoUrl, setLogoUrl] = useState("");

  useEffect(() => {
    const url = getFullUrl("image/logo_app_blanco");
    setLogoUrl(url);
  }, []);

  const next = () => {
    setAnimation("slide-out");
    setTimeout(() => {
      setStep(step + 1);
      setAnimation("slide-in");
    }, 300);
  };

  const prev = () => {
    setAnimation("slide-out-prev");
    setTimeout(() => {
      setStep(step - 1);
      setAnimation("slide-prev");
    }, 300);
  };

  switch (step) {
    case 1:
      return (
        <RegisterCode
          next={next}
          animation={animation}
          setContact={setContact}
          setRif={setRif}
          setMethod={setMethod}
          logoUrl={logoUrl}
        />
      );
    case 2:
      return (
        <RegisterVeriCode
          prev={prev}
          next={next}
          animation={animation}
          contact={contact}
          rif={rif}
          method={method}
          setCodigo={setCodigo}
          setCorreo={setCorreo}
          logoUrl={logoUrl}
        />
      );
    case 3:
      return (
        <RegisterPassword
          prev={prev}
          animation={animation}
          contact={contact}
          rif={rif}
          codigo={codigo}
          correo={correo}
          setCorreo={setCorreo}
          logoUrl={logoUrl}
        />
      );
    default:
      return (
        <RegisterCode
          next={next}
          animation={animation}
          logoUrl={logoUrl}
        />
      );
  }
};

export default RegisterView;
